import gql from 'graphql-tag';

export const CREATE_PRESCRIPTION_AND_PD = gql`
  mutation createPrescriptionAndPdUser($input: PrescriptionAndPdInput!) {
    createPrescriptionAndPd(input: $input) {
      id
      add_near
      created_at
      left_int_add
      right_int_add
      left_near_add
      right_near_add
      right_sph
      left_axis
      left_cyl
      left_sph
      right_axis
      right_cyl
      note
      standardised_prescription_display_array {
        right
        left
        add
      }
      pd {
        id
        binocular_dist_pd
        right_monocular_dist_pd
        left_monocular_dist_pd
        right_height_multifocal
        left_height_multifocal
        frame_size
        arm_size
        glass_shape_type
      }
      files {
        id
        file_name
        thumbnail_path
        full_path
      }
    }
  }
`;

export const EDIT_PRESCRIPTION_AND_PD = gql`
  mutation editPrescriptionAndPdUser($input: PrescriptionAndPdInput!) {
    editPrescriptionAndPd(input: $input) {
      id
      add_near
      created_at
      left_int_add
      right_int_add
      left_near_add
      right_near_add
      right_sph
      left_axis
      left_cyl
      left_sph
      right_axis
      right_cyl
      note
      created_at
      standardised_prescription_display_array {
        right
        left
        add
      }
      pd {
        id
        type
        binocular_dist_pd
        right_monocular_dist_pd
        left_monocular_dist_pd
        right_height_multifocal
        left_height_multifocal
        frame_size
        arm_size
        glass_shape_type
      }
      files {
        id
        file_name
        thumbnail_path
        full_path
      }
    }
  }
`;

export const CREATE_PD = gql`
  mutation createPdUser($input: PdInput!) {
    createPd(input: $input) {
      id
      binocular_dist_pd
      right_monocular_dist_pd
      left_monocular_dist_pd
      right_height_multifocal
      left_height_multifocal
      frame_size
      arm_size
      glass_shape_type
    }
  }
`;

export const DELETE_PRESCRIPTION = gql`
  mutation deletePrescriptionUser($input: DeletePrescriptionInput!) {
    deletePrescription(input: $input) {
      message
    }
  }
`;

export const UPDATE_PRESCRIPTION_PD_BY_ID = gql`
  mutation insertPdToPrescription($input: PrescriptionAndPdInput!) {
    insertPdToPrescription(input: $input) {
      id
      pd {
        id
      }
    }
  }
`;